import React from "react";

export const Header: React.FC = () => (
  <header>
    <div className="container header-inner">
      <div className="logo">
        KOD<span>GOD</span>.RU
      </div>
      <div className="header-tagline">
        Разработка программного обеспечения и&nbsp;интеграция IT-инфраструктуры
        для малого и среднего бизнеса.
      </div>
    </div>
  </header>
);
